module.exports = __webpack_public_path__ + "img/door-icon-green.5c89524b.png";